//Header with no bottom margin to push away elements

import star from "../../../assets/UI/star.png";
import { Link } from 'react-router-dom';
import HomeIcon from "../../../assets/UI/HomeIcon.png"
import './Header_Nav_NBM.css';


export default function HeaderNavNBM({GoBack_to}) {
  return (
    <div>
        <div className="HomeHeader-nv-ntm">
        
        
            {/* Logo */}
            <div className="Logo-nv">
                <img src={star} className="star-nv-ntm" alt="Logo Star" />
                <h1 className="LogoTxt1-nv-ntm">Hangeul</h1>
                <h1 className="LogoTxt2-nv-ntm">Hero</h1>
            </div >
            <p className="Slogan-nv-ntm">Learn Korean the fun way!</p>
        </div>
      
      {/* Pink Narrow Banner */}
      <div className="narrow-banner-nv-ntm">

        <div className="NarrowBannerElements-nv-ntm">
            <div className="HomeElements-ntm">
                <div>
                    <Link to="/" className="HomeLink-nv-ntm"><img src={HomeIcon} alt="Home Icon" className="HomeIcon-nv-ntm" /></Link>
                </div>
                
                <div>
                    <Link to="/" className="NavLink-nv-ntm"><p className="NarrowBannerHomeTxt-nv-ntm">HOME</p></Link>
                </div>
            </div>
            
            <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">|</p>
            </div>

            <div>
                <Link to={GoBack_to} className="NavLink-nv-ntm"><p className="NarrowBannerHomeTxt-nv-ntm">GO BACK</p></Link>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">||</p>
            </div>

             <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">PHONETICS</p>
            </div>

             <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">FLASHCARDS</p>
            </div>
            
            <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">GAMES & ACTIVITIES</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">|</p>
            </div>

            <div>
                <p className="NarrowBannerHomeTxt-nv-ntm">GRAMMAR</p>
            </div>
        
        </div>
    
    </div>

</div>
        
  )
}